<template>
  <div>
    <div class="fast-modal-content">
      <Teleport to="#fast-title">Choisissez un niveau de visibilité</Teleport>

      <Loading v-show="loading" />

      <div class="flex max-md:flex-col gap-4 mb-6">
        <div
          v-for="option in projectOptions"
          :key="option.id"
          class="rounded-xl border border-solid border-neutral-200 flex flex-col grow"
        >
          <h3 class="m-4 mt-6 text-center text-body font-medium">{{ option.name }}</h3>

          <p class="text-center text-4xl font-medium">
            <span class="bg-clip-text text-transparent bg-primary-gradient">{{ option.price_pretax }} €&nbsp;</span>
            <span class="text-sm align-top text-primary">HT</span>
          </p>
          <div class="p-4 grow">
            <div v-for="(perk, index) in option.content_highlight.split('\n')" :key="index" class="py-2">
              <fa-icon type="far" icon="check" class="text-primary mr-2" />
              <span v-html="perk"></span>
            </div>
          </div>

          <div class="p-4 text-center">
            <button type="button" class="btn py-4 px-8 btn-primary" @click.prevent="handleClick(option)">
              Sélectionner
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex max-md:gap-4 max-md:flex-col justify-between items-center p-8">
      <button type="button" class="btn font-semibold text-body" @click.prevent="handlePrevStep()">Retour</button>
      <button
        type="button"
        class="btn btn-outline-primary py-4 px-8 md:ml-auto max-md:w-full"
        @click.prevent="handleClick(freeOption)"
      >
        Publier gratuitement
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import Loading from './Loading.vue'
import stepEvents from '../mixins/stepEvents'

export default {
  name: 'StepProjectOption',
  components: {
    Loading
  },
  mixins: [stepEvents],
  data() {
    return {
      loading: true,
      freeOption: null,
      projectOptions: []
    }
  },
  mounted() {
    axios.get('/api/project_options').then(response => {
      this.freeOption = response.data.free_option
      this.projectOptions = response.data.project_options
      this.loading = false
    })
  },
  methods: {
    handleClick(option) {
      this.$emit('attributeChange', 'projectOptionId', option.id)
      this.$emit('done')
    }
  }
}
</script>
